import {
  SimpleWeekTimeModelResponse,
  SimpleWeekTimeModelResponseItem
} from '@/types/service-response'

export class SimpleWeekTimeModel {
  public constructor (
    readonly id: string,
    readonly name: string,
    readonly ABW: string,
    readonly KAL: string,
    readonly MDT_IDENT_NR: string,
    readonly MOD_IDENT_NR: string,
    readonly monday: string,
    readonly mondayFrom: string | null,
    readonly mondayTo: string | null,
    readonly tuesday: string,
    readonly tuesdayFrom: string | null,
    readonly tuesdayTo: string | null,
    readonly wednesday: string,
    readonly wednesdayFrom: string | null,
    readonly wednesdayTo: string | null,
    readonly thursday: string,
    readonly thursdayFrom: string | null,
    readonly thursdayTo: string | null,
    readonly friday: string,
    readonly fridayFrom: string | null,
    readonly fridayTo: string | null,
    readonly saturday: string,
    readonly saturdayFrom: string | null,
    readonly saturdayTo: string | null,
    readonly sunday: string,
    readonly sundayFrom: string | null,
    readonly sundayTo: string | null,
    readonly validFrom: string,
    readonly modelType: string
  ) {}

  static createListFromResponse (data: SimpleWeekTimeModelResponse): Array<SimpleWeekTimeModel> {
    return data.map((item: SimpleWeekTimeModelResponseItem) => {
      return new SimpleWeekTimeModel(
        item.ID,
        item.Name,
        item.ABW_Gutschrift,
        item.KAL_Gutschrift,
        item.MDT_IDENT_NR,
        item.MOD_IDENT_NR,
        item.Montag,
        item.MontagVon,
        item.MontagBis,
        item.Dienstag,
        item.DienstagVon,
        item.DienstagBis,
        item.Mittwoch,
        item.MittwochVon,
        item.MittwochBis,
        item.Donnerstag,
        item.DonnerstagVon,
        item.DonnerstagBis,
        item.Freitag,
        item.FreitagVon,
        item.FreitagBis,
        item.Samstag,
        item.SamstagVon,
        item.SamstagBis,
        item.Sonntag,
        item.SonntagVon,
        item.SonntagBis,
        item.GueltigAb ? item.GueltigAb : '',
        item.MIT_GRUPPE
      )
    })
  }
}
